export const texts = {
    "id": "ID",
    "id_origem": "ID Origem",
    "dataentrada": "Data da entrada",   
    "estagio": "Status do Lead",
    "dataproxatividade": "Data do próximo contato",
    "dataultatividade": "Data do último contato",
    "dataapropriacao": "Data da apropriação",
    "idusuario": "ID Usuário",
    "email": "E-mail",  
    "qtadultos": "Qntd Adultos",
    "qtdcriancas": "Qntd Crianças",
    "nome": "Nome",
    "empresa": "Empresa",
    "telefone": "Telefone",
    "celular": "Celular",
    "tipohotel": "Tipo do Hotel",
    "destino": "Destino",
    "cidade": "Cidade",
    "hotelpreferencia": "Hotel de preferência",
    "dataviagemprevista": "Data da viagem prevista",
    "qtdnoites": "Qntd Noites",
    "A": "Aberto (A)",
    "L": "Aberto (A)",
    "T": "Trabalhando (T)",
    "C": "Cliente (C)",
    "P": "Perdido (P)"

};